const NEXUS_KEY = 'nexus_token';

export function getNexusToken(): string {
  return localStorage.getItem(NEXUS_KEY) || '';
}

export function hasNexusToken(): boolean {
  return !!localStorage.getItem(NEXUS_KEY);
}

export function authHeaders(): Record<string, string> {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getNexusToken()}`,
  };
}

export function clearNexusToken(): void {
  localStorage.removeItem(NEXUS_KEY);
}
